import type {
  FeatureToggle,
  FeatureToggleIdentifier,
} from '@schema/featureToggle'

type FeatureToggleLike = Pick<FeatureToggle, 'identifier' | 'enabled'>

/**
 * Returns whether the given identifier is enabled in the toggles list.
 */
export const isFeatureEnabled = (
  toggles: FeatureToggleLike[] | undefined,
  identifier: FeatureToggleIdentifier,
): boolean => {
  return (
    toggles?.some((ft) => ft.identifier === identifier && ft.enabled) ?? false
  )
}

const hasContent = (value: unknown): boolean => {
  if (!value) return false
  if (Array.isArray(value)) return value.length > 0
  return true
}

/**
 * Feature toggle must be enabled AND at least one of the provided
 * data sources must be non-null / non-empty.
 * If no requiredData is passed, only the toggle is checked.
 */
export const isFeatureAvailable = (
  toggles: FeatureToggleLike[] | undefined,
  identifier: FeatureToggleIdentifier,
  requiredData?: unknown[],
): boolean => {
  if (!isFeatureEnabled(toggles, identifier)) return false
  if (!requiredData || requiredData.length === 0) return true
  return requiredData.some(hasContent)
}
